import React, { useState, useMemo, useCallback } from 'react'
import { findAttributeItems } from '../../services/attributeService'
import { Select } from 'antd'
import bxlUtils from 'bxl-utils'

const { Option } = Select

const AsyncAttributeItemSelect = (props: any) => {
  const {
    value,
    onChange,
    mode,
    placeholder,
    showArrow = true,
    showSearch = true,
    allowClear = true,
    notFoundContent,
    optionFilterProp,
  } = props
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const onSearch = useMemo(() => bxlUtils.debounce(500, value => {
    if (value) {
      setLoading(true)
      findAttributeItems(0, 1000, value)
        .then(res => {
          setTimeout(() => {
            setItems(res.data.items)
            setLoading(false)
          }, 100)
        })
        .catch(e => {
          setLoading(false)
          setItems([])
        })
    } else {
      setItems([])
      setLoading(false)
    }
  }), [])

  const onChangeInternal = useCallback((value) => {
    const item = items?.find((i: any) => i.id === value)
    onChange && onChange(item)
  }, [items, onChange])

  return (
    <Select
      value={value}
      showSearch={showSearch}
      allowClear={allowClear}
      mode={mode}
      optionFilterProp={optionFilterProp || 'children'}
      placeholder={placeholder}
      defaultActiveFirstOption={false}
      autoClearSearchValue
      showArrow={showArrow}
      filterOption={false}
      onSearch={onSearch}
      onChange={onChangeInternal}
      notFoundContent={notFoundContent}
      loading={loading}
    >
      {items?.map((item: any) => (
        <Option value={item.id} key={item.id}>
          {item.value}
        </Option>
      ))}
    </Select>
  )
}

export default AsyncAttributeItemSelect
